module.exports = {"hos":{"header":{"mypolls":"আমার জরিপ"},"intro":{"title":"@:txt.date"}},"meta":{"lead":"তোমার জরিপ তৈরি করো"}};